import _ from 'lodash';
import {Directive, Module} from 'app/decorators';


@Module({
    name: "app.directives.autofocus",
})
@Directive('autofocus', function($timeout){
    "ngInject";
    return {
        restrict: 'A',
        link: function ($scope, $element) {
            $timeout(function () {
                $element[0].focus();
            });
        }
    };
})
export default class D {}



// WEBPACK FOOTER //
// ./src/app/directives/autofocus.js